export var ToolbarDesign;
(function (ToolbarDesign) {
    ToolbarDesign["Auto"] = "Auto";
    ToolbarDesign["Info"] = "Info";
    ToolbarDesign["Solid"] = "Solid";
    ToolbarDesign["Transparent"] = "Transparent";
})(ToolbarDesign || (ToolbarDesign = {}));
